import{createJSONStorage}from"jotai/utils";export const createStorage=()=>{const storage=createJSONStorage();delete storage.subscribe;return storage};